/* eslint-disable no-unused-vars */

import {
  Box,
  Button,
  Container,
  Grid,
  LinearProgress,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuProps,
  Tooltip,
  Typography,
  withStyles
} from '@material-ui/core';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { Page } from 'src/components';
import VoucherIcon from 'src/components/icons/VoucherIcon';
import useResolution from 'src/hooks/useResolution';
import { Toolbar } from './components/Toolbar';
import { VoucherTable } from './components/VoucherTable';
import { MobileVoucherList } from './components/MobileVoucherList';
import { useNavigate } from 'react-router';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddBoxIcon from '@material-ui/icons/AddBox';

import { useVouchers } from 'src/hooks/useVouchers';
import { usePermissions } from 'src/hooks';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    marginTop: 3
  }
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    color: theme.palette.text.primary
  }
}))(MenuItem);

export const VouchersListingPage: FC = () => {
  const { canCreateVoucher } = usePermissions();
  const navigate = useNavigate();
  const { lg, isMobile } = useResolution();
  const { getVouchers, isListLoading } = useVouchers();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const toggleCreateMenu = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      const value = anchorEl ? null : event.currentTarget;
      setAnchorEl(value);
    },
    [anchorEl]
  );

  const onClickCreateNomal = useCallback(() => {
    navigate(`/app/vouchers/create`);
  }, [navigate]);

  const onClickCreateGeneric = useCallback(() => {
    navigate(`/app/vouchers/create?mode=generic`);
  }, [navigate]);

  useEffect(() => {
    getVouchers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page className="root" title="Vouchers">
      <Box style={{ padding: ' 3em 2em 1em' }}>
        <Grid container style={{ rowGap: '1em' }}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h1">Voucher List</Typography>
          </Grid>
          {canCreateVoucher ? (
            <Grid
              item
              xs={12}
              sm={6}
              style={{ display: 'flex', justifyContent: 'end', gap: '1em' }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={toggleCreateMenu}
              >
                <>
                  Create Voucher
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingBottom: 3,
                      marginLeft: 4
                    }}
                  >
                    {anchorEl ? (
                      <ExpandLessIcon style={{ fontSize: 20 }} />
                    ) : (
                      <ExpandMoreIcon style={{ fontSize: 20 }} />
                    )}
                  </span>
                </>
              </Button>

              <StyledMenu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={toggleCreateMenu}
              >
                <>
                  <Tooltip title="Click here to create a normal voucher" arrow>
                    <StyledMenuItem onClick={onClickCreateNomal}>
                      <ListItemIcon>
                        <AddBoxIcon fontSize="small" color="primary" />
                      </ListItemIcon>
                      <ListItemText primary="Standard" />
                    </StyledMenuItem>
                  </Tooltip>
                  <Tooltip title="Click here to create a generic voucher" arrow>
                    <StyledMenuItem onClick={onClickCreateGeneric}>
                      <ListItemIcon>
                        <AddCircleIcon fontSize="small" color="primary" />
                      </ListItemIcon>
                      <ListItemText primary="Generic" />
                    </StyledMenuItem>
                  </Tooltip>
                </>
              </StyledMenu>
            </Grid>
          ) : null}
        </Grid>
      </Box>
      <Toolbar />
      {isListLoading ? <LinearProgress /> : null}
      {lg && !isListLoading ? <MobileVoucherList /> : null}
      {!lg && !isListLoading ? <VoucherTable /> : null}
    </Page>
  );
};
